import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios';
import store from './store'
// import api from '../api/api'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.use(ElementPlus)
app.use(router)
app.use(store)
// 注册axios
app.config.globalProperties.$axios = axios;
app.use(VueAxios, axios)
app.mount('#app')
